if(!customElements.get('product-list')) {
  customElements.define('product-list',
    class ProductList  extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-section-id');
        this.dataGet = this.getAttribute('data-type');
        this.init(this);
      }


      getDynamicKey(hoursInterval = 6) {
        const now = new Date();
        const roundedHour = Math.floor(now.getHours() / hoursInterval) * hoursInterval;
        return `myData_${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${roundedHour}`;
      }

      init(self) {
        const parser = new DOMParser();
        let typeGetData = self.dataGet;
        let sectionId = self.sectionId;
        if (typeGetData === 'block' || typeGetData === 'collection' || typeGetData === 'product_list') {
          renderSwiper(sectionId);
        } else {
          let listProduct = [];
          let listProductNew = [];
          let key = this.getDynamicKey(6);
          if (localStorage.getItem(`product-recently-${key}`)) {
            listProduct = JSON.parse(localStorage.getItem(`product-recently-${key}`));
          }
          if (listProduct.length > 0) {
            listProduct.forEach((product) => {
              const productDataHTML = parser.parseFromString(product.data, 'text/html');
              let productPrice;

              if (productDataHTML.querySelector('.price').classList.contains('price--on-sale')) {
                productPrice = productDataHTML
                  .querySelector('.price-item.price-item--sale')
                  .textContent.trim()
                  .replace('€', '');
              } else {
                productPrice = productDataHTML
                  .querySelector('.price-item.price-item--regular')
                  .textContent.trim()
                  .replace('€', '');
              }

              if(productPrice !== '0') {
                listProductNew.push(product)
              }
            });

            const newArray = listProductNew.reverse();
            let elParent = document.getElementById(`list-product-${sectionId}`);
            newArray.forEach((item) => {
              let htmlProduct = item.data;
              let elDiv = document.createElement('div');
              elDiv.className = 'swiper-slide item-product';
              elDiv.innerHTML = htmlProduct;
              elParent.appendChild(elDiv);
            });
            renderSwiper(sectionId);
          } else {
            document.getElementById(`product-list-${sectionId}`).style.display = 'none';
          }
        }

        function renderSwiper(sectionId) {
          new Swiper(`#swiper-${sectionId}`, {
            navigation: {
              nextEl: `.swiper-button-next-${sectionId}`,
              prevEl: `.swiper-button-prev-${sectionId}`,
            },
            slidesPerView: 1.5,
            spaceBetween: 4,
            breakpoints: {
              990: {
                slidesPerView: 3.795,
              },
            },
            mousewheel: {
              forceToAxis: true,
            }
          });
        }
      }
    }
  )
}